import React from "react";

import clsx from "clsx";

import styles from "./Logo.module.scss";

interface ILogoProps {
  className?: string;
}

export const Logo: React.FC<ILogoProps> = ({ className }) => {
  const classes = clsx(styles.base, className);

  return <div className={classes}></div>;
};
